import {ADD_USER, GET_USER} from './types.js';

export const addUsers = (data)=>(dispatch)=>{
    dispatch({
        type:ADD_USER,
        payload:{data}
    })
}

export const getChart = (data)=>(dispatch)=>{
    dispatch({
        type:GET_USER,
        payload:{data}
    })
}
